import React, { useState } from 'react';
import { SendIcon, CheckCircleIcon } from 'lucide-react';
export function RequestForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    flowerType: '',
    description: '',
    budget: '',
    deadline: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        flowerType: '',
        description: '',
        budget: '',
        deadline: ''
      });
    }, 1500);
  };
  return <section className="py-16 bg-pink-50" id="request-form" data-id="element-381">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-382">
        <div className="text-center mb-12" data-id="element-383">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-384">
            Can't Find What You're Looking For?
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-385">
            Request a specific flower or plant and our florists will get back to
            you within 24 hours
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-md overflow-hidden max-w-3xl mx-auto" data-id="element-386">
          <div className="p-8" data-id="element-387">
            {isSubmitted ? <div className="text-center py-8" data-id="element-388">
                <CheckCircleIcon className="h-16 w-16 text-pink-600 mx-auto mb-4" data-id="element-389" />
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-390">
                  Request Received!
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-391">
                  Thank you for your custom flower request. Our team will get
                  back to you within 24 hours.
                </p>
                <button onClick={() => setIsSubmitted(false)} className="px-6 py-2 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors" data-id="element-392">
                  Submit Another Request
                </button>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-393">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-394">
                  <div data-id="element-395">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-396">
                      Your Name*
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-pink-600 focus:border-pink-600" data-id="element-397" />
                  </div>
                  <div data-id="element-398">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-399">
                      Email Address*
                    </label>
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-pink-600 focus:border-pink-600" data-id="element-400" />
                  </div>
                </div>
                <div data-id="element-401">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-402">
                    Phone Number*
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-pink-600 focus:border-pink-600" data-id="element-403" />
                </div>
                <div data-id="element-404">
                  <label htmlFor="flowerType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-405">
                    What type of flower/plant are you looking for?*
                  </label>
                  <input type="text" id="flowerType" name="flowerType" required value={formData.flowerType} onChange={handleChange} placeholder="E.g., Rare orchids, Specific rose variety, Seasonal flowers" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-pink-600 focus:border-pink-600" data-id="element-406" />
                </div>
                <div data-id="element-407">
                  <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-408">
                    Additional Details
                  </label>
                  <textarea id="description" name="description" rows={4} value={formData.description} onChange={handleChange} placeholder="Please describe any specific requirements, colors, or arrangement styles you're looking for" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-pink-600 focus:border-pink-600" data-id="element-409" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-410">
                  <div data-id="element-411">
                    <label htmlFor="budget" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-412">
                      Budget Range (KES)
                    </label>
                    <select id="budget" name="budget" value={formData.budget} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-pink-600 focus:border-pink-600" data-id="element-413">
                      <option value="" data-id="element-414">Select a range</option>
                      <option value="Under 3,000" data-id="element-415">Under 3,000</option>
                      <option value="3,000 - 5,000" data-id="element-416">3,000 - 5,000</option>
                      <option value="5,000 - 10,000" data-id="element-417">5,000 - 10,000</option>
                      <option value="Above 10,000" data-id="element-418">Above 10,000</option>
                    </select>
                  </div>
                  <div data-id="element-419">
                    <label htmlFor="deadline" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-420">
                      When do you need it by?
                    </label>
                    <input type="date" id="deadline" name="deadline" value={formData.deadline} onChange={handleChange} min={new Date().toISOString().split('T')[0]} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-pink-600 focus:border-pink-600" data-id="element-421" />
                  </div>
                </div>
                <div className="text-right" data-id="element-422">
                  <button type="submit" disabled={isLoading} className="px-6 py-3 bg-pink-700 text-white rounded-md hover:bg-pink-800 transition-colors flex items-center justify-center space-x-2 disabled:bg-pink-400 disabled:cursor-not-allowed" data-id="element-423">
                    {isLoading ? <>
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-424">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-425"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-426"></path>
                        </svg>
                        <span data-id="element-427">Submitting...</span>
                      </> : <>
                        <SendIcon className="h-5 w-5 mr-1" data-id="element-428" />
                        <span data-id="element-429">Submit Request</span>
                      </>}
                  </button>
                </div>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}